export type ProposalLocale = "pt" | "en" | "es";

export type TranslationDictionary = Record<string, string>;

export const SUPPORTED_LOCALES: ProposalLocale[] = ["pt", "en", "es"];

export const LOCALE_LABELS: Record<ProposalLocale, string> = {
  pt: "PT",
  en: "EN",
  es: "ES",
};

export const LOCALE_FLAGS: Record<ProposalLocale, string> = {
  pt: "🇧🇷",
  en: "🇺🇸",
  es: "🇪🇸",
};
